/**
 * otomochi と同じ運営者（ヘイリック）が運営する Misskey サーバー「ころがすきー」の
 * 紹介バナー設定。文言・リンク・画像を一箇所に集約する。
 */

export const KOROKORO_PROMO = {
  /** サーバー名 */
  name: 'ころがすきー',
  url: 'https://korokoro.club/',
  /** 一言での説明（画像を出せない狭い画面で使う） */
  tagline: 'TRPG好きが集まる Misskey サーバー',
  /**
   * 配布されたバナー画像（キャッチコピー・CTA・年齢条件まで焼き込み済みの完成品）。
   * null にすると画像を使わないテキスト版にフォールバックする。
   */
  imageSrc: '/images/korokoro-banner.png' as string | null,
  /** 画像の実寸。width/height を渡してレイアウトシフトを防ぐため保持する */
  imageWidth: 1456,
  imageHeight: 180,
  /**
   * 画像内の文字を読み上げへ引き渡す代替テキスト。
   * 画像に文字が焼き込まれているため、見えている情報をそのまま書き出す。
   */
  imageAlt:
    'ころがすきー — 日常もTRPGも創作も、ころころ話す。クリエイターにやさしいMisskeyサーバー・非営利で個人運営。korokoro.club（20歳以上・登録オープン）',
  /** 登録の年齢条件。誘導する以上、クリック前に読める大きさで必ず出す */
  ageNote: '20歳以上の方が登録・利用できます',
} as const;
